export default "__VITE_ASSET__BwpTmUvE__"